import axios from "axios";
import { Fragment, useEffect, useState } from "react";
import CustomTable from "../../../../components/CustomTable";
import { parseFirebaseDateTime } from "../../../../utils/helper";
import { getNameByProductId } from "../../../Subscriptions/constants/packages";
import { getSubscriptionsByUserId } from "../../../Subscriptions/APIS/subscriptionApis";
import { Tag } from "antd";

const UserInvoices = ({ user_id }) => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: "Package Name",
      dataIndex: "prod_id",
      render: (product_id) => {
        return getNameByProductId(product_id) || "-";
      },
    },
    {
      title: "Customer Email",
      dataIndex: "payload",
      render: (_, record) => {
        const metadata = record?.payload?.metadata?.user_details
          ? JSON.parse(record?.payload?.metadata?.user_details)
          : {};
        const payload_email = metadata?.user_email || "-";
        return record?.user_details?.user_email || payload_email;
      },
    },
    {
      title: "Start Date",
      dataIndex: "payload",
      render: (_, record) => {
        let start_date;
        if (record?.status === "active") {
          if (record?.payload?.start_date) {
            start_date = new Date(record?.payload?.start_date * 1000)
              .toString()
              .slice(0, 21);
          } else if (record?.payload?.current_period_start) {
            start_date = new Date(record?.payload?.current_period_start * 1000)
              .toString()
              .slice(0, 21);
          }
        } else {
          start_date = parseFirebaseDateTime(record?.trial_starts_at)
            ?.toString()
            .slice(0, 21);
        }
        return start_date ?? "N/A";
      },
    },

    {
      title: "End Date",
      dataIndex: "end_date",
      render: (_, record) => {
        return record?.end_date
          ? new Date(record?.end_date).toString().slice(0, 21)
          : "N/A";
      },
    },

    {
      title: "Status",
      dataIndex: "status",
      render: (status) => {
        const statusMap = {
          active: "Active",
          trialing: "Trialing",
          canceled: "Canceled",
          paused: "Paused",
          incomplete: "Incomplete",
          expired: "Expired",
        };

        const statusColors = {
          active: "green",
          trialing: "blue",
          canceled: "red",
          paused: "gray",
          expired: "yellow",
        };
        return (
          <Tag color={`${statusColors[status]}`}>
            {statusMap[status] || status}
          </Tag>
        );
      },
    },
  ];

  const getUserSubscriptions = async (user_id) => {
    try {
      setLoading(true);
      let response = await getSubscriptionsByUserId(user_id);
      console.log("response", response);
      setSubscriptions(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user_id) getUserSubscriptions(user_id);
  }, [user_id]);

  return (
    <Fragment>
      <CustomTable
        dataSource={subscriptions}
        columns={columns}
        loading={loading}
      />
    </Fragment>
  );
};

export default UserInvoices;
